import { createStore } from 'jotai'

export function useThankYouScreenStore({ overrideStore }: { overrideStore?: ReturnType<typeof createStore> }) {
	if (!overrideStore) {
		throw new Error('useThankYouScreenStore requires a store to be passed via overrideStore prop.')
	}
	return overrideStore
}
